import { render, staticRenderFns } from "./AbilityWrapper.vue?vue&type=template&id=66674a68&"
import script from "./AbilityWrapper.vue?vue&type=script&lang=js&"
export * from "./AbilityWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports